import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { mainBodyList, mainBodyDetail } from '@/api/gucangSales/customerCenter'
import { mainBodyStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { useRoute } from 'vue-router'
import { tableIdByPath } from '@/utils'

const __default__ = { name: 'tabsMainBody' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const columns = computed(() => [
  { title: '子客户代码', dataIndex: 'customerCode' },
  { title: '账户编号', dataIndex: 'accountCode', headerQuestion: '取值来源：ark签约主体管理-账户编号' },
  { title: '签约主体', dataIndex: 'signBodyName', headerQuestion: '取值来源：ark签约主体管理-主体名称' },
  { title: '服务主体', dataIndex: 'serviceBodyName', headerQuestion: '取值来源：ark签约主体管理-服务主体' },
  {
    title: '主体联系人',
    dataIndex: 'contactName',
    cosType: 'mask',
    headerQuestion: '取值来源：ark签约主体管理-联系人姓名',
    width: 130
  },
  {
    title: '主体手机号码',
    dataIndex: 'phoneNumber',
    cosType: 'mask',
    headerQuestion: '取值来源：ark签约主体管理-联系电话',
    width: 145
  },
  {
    title: '可用余额',
    dataIndex: 'signBodyBalanceList',
    headerQuestion: '取值来源：ark签约主体管理-可用余额',
    width: 200
  },
  { title: '信用额度', dataIndex: 'totalQuota', headerQuestion: '取值来源：ark签约主体管理-信用额度' },
  { title: '总可用额度', dataIndex: 'allTotal', headerQuestion: '取值来源：ark签约主体管理-总可用额度', width: 130 },
  { title: '出账周期', dataIndex: 'accountCycleTypeStr', headerQuestion: '取值来源：ark签约主体管理-出账周期' },
  { title: '对账周期', dataIndex: 'reconciliationCycleTypeStr', headerQuestion: '取值来源：ark签约主体管理-对账周期' },
  { title: '签约业务', dataIndex: 'signBusinessTypeStr', headerQuestion: '取值来源：ark签约主体管理-签约业务' },
  {
    title: '已签约业务',
    dataIndex: 'contractedBusinessStr',
    headerQuestion: '取值来源：ark签约主体管理-已签约业务',
    width: 130
  },
  {
    title: '注册国家/区域',
    dataIndex: 'registerAreaCode',
    headerQuestion: '取值来源：ark签约主体管理-注册国家/区域',
    width: 160
  },
  {
    title: '主体类别',
    dataIndex: 'type',
    dicData: [
      { value: 'C101', label: '个人' },
      { value: 'C102', label: '公司' }
    ],
    headerQuestion: '取值来源：ark签约主体管理-主体类别'
  },
  {
    title: '状态',
    dataIndex: 'signBodyStatus',
    dicData: mainBodyStatusEnum,
    headerQuestion: '取值来源：ark签约主体管理-状态'
  },
  { title: '审核时间', dataIndex: 'examineTime', headerQuestion: '取值来源：ark签约主体管理-审核时间', width: 190 },
  {
    title: '客户负责人',
    dataIndex: ['customer', 'sellerName'],
    headerQuestion: '取值来源：ark签约主体管理-销售代表',
    width: 130
  },
  { title: '负责人区域', dataIndex: ['customer', 'sellerRegion'], width: 190 }
])
const getList = (queryForm: any, callBack: (res: any) => void) => {
  if (route.query.cosId) {
    mainBodyList({
      customer: {
        cosId: route.query.cosId
      },
      ...queryForm
    }).then((res) => {
      callBack(res)
    })
  }
}

// 获取详情信息
const showMask = (record: any, callBack: (res: any) => void) => {
  mainBodyDetail({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: getList,
    onMask: showMask,
    tableId: _unref(tableIdByPath)('mainBody')
  }, {
    bodyCell: _withCtx(({ column, text }) => [
      (column.dataIndex === 'customer.sellerRegion')
        ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
            key: 0,
            appId: "cos_fbu",
            value: text
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (column.dataIndex === 'signBodyBalanceList')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(text?.map((item) => `${item.currencyCode}：${item.quota}`).join('、') || '--'), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "tableId"]))
}
}

})